import { StarOutlined } from '@ant-design/icons';
import React from 'react';
import { peopleFilled } from '../../assets';
import Wrapper from './style';
import authorizeList from './authorize.config';

const Index = (props) => {
  const { type = 'Twitter', used = 1, total = 2 } = props;
  const authorizeData = authorizeList.find((item) => {
    return item.value === type;
  });

  return (
    <Wrapper>
      <div className="container_authorize_wrapper">
        <div className="component_authorize_title">
          <img src={peopleFilled} alt="people icon" />
          <div className="font-subtitle1_medium black1">
            {authorizeData.title}
          </div>
        </div>
        <div className="component_authorize_box">
          <StarOutlined />
          <div className="font-caption">
            {`You’re using ${used} of ${total} profiles available on your current plan. To
            unlock additional profiles and features, `}
            <span className="orange1">Buy new license </span>
            for using this
          </div>
        </div>
        <div className="font-paragraph black1 component_authorize_permission">
          {authorizeData.permisionText}
        </div>
        <div className="component_authorize_image">
          <img src={authorizeData.image} alt="authorize" />
        </div>
      </div>
    </Wrapper>
  );
};

export default Index;
